import { ComponentInternalInstance, getCurrentInstance } from '@vue/composition-api';
import _ from 'lodash';
import tips from '@/renderer/scripts/utils/tips';
import smh from '@/renderer/scripts/smh';

type Handler = {
  methods: {
    monitoringStepsDone: (stepName: string, step: number) => void;
  };
};
export default function guideHandle(): Handler {
  const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
  const vm = currComponent.proxy;
  const store = vm.$store;

  const methods = {
    reportGuide(guideSteps: Array<number>, guideName: string) {
      if (guideSteps.length === 2) {
        if (guideSteps[0] && !guideSteps[1]) {
          reporter.report(guideName, {
            success_count_type: 'mission_two_create',
          });
        }
        if (!guideSteps[0] && guideSteps[1]) {
          reporter.report(guideName, {
            success_count_type: 'mission_two_invite',
          });
        }
        if (guideSteps[0] && guideSteps[1]) {
          reporter.report(guideName, {
            success_count_type: 'mission_two_create_invite',
          });
        }
        return;
      }
      if (guideSteps[0] && !guideSteps[1] && !guideSteps[2]) {
        reporter.report(guideName, {
          success_count_type: 'mission_one_one_upload',
        });
      } else if (!guideSteps[0] && guideSteps[1] && !guideSteps[2]) {
        reporter.report(guideName, {
          success_count_type: 'mission_one_one_check',
        });
      } else if (!guideSteps[0] && !guideSteps[1] && guideSteps[2]) {
        reporter.report(guideName, {
          success_count_type: 'mission_one_one_share',
        });
      } else if (guideSteps[0] && guideSteps[1] && !guideSteps[2]) {
        reporter.report(guideName, {
          success_count_type: 'mission_one_two_upload_check',
        });
      } else if (guideSteps[0] && !guideSteps[1] && guideSteps[2]) {
        reporter.report(guideName, {
          success_count_type: 'mission_one_two_upload_share',
        });
      } else if (!guideSteps[0] && guideSteps[1] && guideSteps[2]) {
        reporter.report(guideName, {
          success_count_type: 'mission_one_two_check_share',
        });
      } else if (guideSteps[0] && guideSteps[1] && guideSteps[2]) {
        reporter.report(guideName, {
          success_count_type: 'mission_one_three_upload_check_share',
        });
      }
    },
    // 对相应步骤进行上报
    handelReportData(stepName: string, allDone: boolean) {
      const { userBaseInfo } = store.getters;
      const { baseGuide } = store.getters.noviceGuidance;
      if (!baseGuide) return;
      let guideName = '';
      let guideSteps = [];
      if (stepName === 'personalSpace') {
        guideSteps = baseGuide.personalSpace.steps;
      } else {
        guideSteps = baseGuide.collaborationSpace.steps;
      }
      switch (userBaseInfo.role) {
        case 'user':
          guideName = 'staff_new_guide_success';
          methods.reportGuide(guideSteps, guideName);
          allDone &&
            reporter.report(guideName, {
              success_count_type: 'mission_finish',
            });
          break;
        case 'admin':
          guideName = 'boss_new_guide_success';
          methods.reportGuide(guideSteps, guideName);
          allDone &&
            reporter.report(guideName, {
              success_count_type: 'mission_finish',
            });
          break;
        case 'superAdmin':
          guideName = 'manager_new_guide_success';
          methods.reportGuide(guideSteps, guideName);
          allDone &&
            reporter.report(guideName, {
              success_count_type: 'mission_finish',
            });
          break;
        default:
          break;
      }
    },
    // 新埋点2.0.1
    reportNewHand(stepName: string, step: number) {
      if (stepName === 'personalSpace') {
        // 上传=0、查看=1、分享=2
        const newHandTypeList = ['upload', 'view', 'share'];
        reporter.report('newhand', {
          newhand_task_finish: newHandTypeList[step],
        });
      } else if (stepName === 'collaborationSpace') {
        // 创建群组=0、邀请加入群组=1
        const newHandTypeList = ['buildgroup', 'invite'];
        reporter.report('newhand', {
          newhand_task_finish: newHandTypeList[step],
        });
      }
    },
    async monitoringStepsDone(stepName: string, step: number) {
      const { baseGuide } = store.getters.noviceGuidance;
      if (baseGuide[stepName] && !baseGuide[stepName]?.steps[step]) {
        try {
          const { steps } = baseGuide[stepName];
          const stepsArr = steps || [0, 0, 0];
          stepsArr.splice(step, 1, 1);
          const opt = {
            ...store.getters.noviceGuidance,
          };
          if (stepName === 'personalSpace' && stepsArr.length === 3 && stepsArr.indexOf(0) === -1) {
            opt.baseGuide.personalSpace.done = true;
          }
          if (stepName === 'collaborationSpace' && stepsArr.length === 2 && stepsArr.indexOf(0) === -1) {
            opt.baseGuide.collaborationSpace.done = true;
          }
          // 需要手动的将完善信息那个给完成，但是不把数据给后台，只做兼容
          const baseGuideDoneArr: boolean[] = [];
          Object.keys(opt.baseGuide).forEach(key => {
            if (!_.isNil(opt.baseGuide[key].done)) {
              if (key === 'personalDetail') {
                baseGuideDoneArr.push(true);
              } else {
                baseGuideDoneArr.push(opt.baseGuide[key].done);
              }
            }
          });
          opt.baseGuide.done = baseGuideDoneArr.indexOf(false) === -1;
          methods.handelReportData(stepName, !!opt.baseGuide.done);
          opt.baseGuide[stepName].steps = stepsArr;
          methods.reportNewHand(stepName, step);
          await smh.userAPI.createNoviceGuidance(opt);
          store.commit('setNoviceGuidance', opt);
        } catch (error: any) {
          tips.error(error as MsgError);
        }
      }
    },
  };
  return {
    methods,
  };
}
